import { RVRoutingPage } from "@regal-voice/ui";

export default function MySettingsRouter(): JSX.Element {
    return <RVRoutingPage />;
}
